@if( (modalDisplayToggle$ | async) == true ) {
    <div class="custom-modal-wrapper backdrop" [class.vertically-centered]="verticallyCentered" [class.show]="(modalDisplayToggle$ | async) == true">
        <div class="custom-modal {{ className }}">
            <ng-content></ng-content>
        </div>
    </div>
}